import cartService from '@/services/cart.service'

export default {
  async fetchCart({ commit }) {
    const res = await cartService.getCart()
    commit('SET_CART', res.data)
  },

  async addToCart({ dispatch }, payload) {
    await cartService.addToCart(payload)
    dispatch('fetchCart')
  },

  async updateQty({ dispatch }, { id, qty }) {
    await cartService.updateItem(id, { quantity: qty })
    dispatch('fetchCart')
  },

  async updateItemsCart( {commit}, payload) {
    commit('SET_ITEMS_CART', payload)
  },
  async removeItem({ dispatch }, id) {
    await cartService.removeItem(id)
    return dispatch('fetchCart')
  }
}